import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Module, Permission } from './roleTypes';

interface PermissionsState {
  modules: Module[];
}

const initialState: PermissionsState = {
  modules: [], // Initialize with an empty array
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setModules(state, action: PayloadAction<Module[]>) {
      return { ...state, modules: action.payload }; // Set the modules and their permissions
    },
    clearModules(state) {
      return { ...state, modules: [] }; // Clear the modules
    },
    updateModulePermissions(state, action: PayloadAction<{ moduleName: string; permissions: Permission }>) {
      const { moduleName, permissions } = action.payload;
      const moduleIndex = state.modules.findIndex((mod) => mod.module === moduleName);
      if (moduleIndex !== -1) {
        const updatedModules = [...state.modules];
        updatedModules[moduleIndex] = { ...updatedModules[moduleIndex], permissions };
        return { ...state, modules: updatedModules };
      }
      return state;
    },
  },
});

export const { setModules, clearModules, updateModulePermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
